export const CREATE_SECTION = 'CREATE_SECTION'
export const UPDATE_SECTION_DATA = 'UPDATE_SECTION_DATA'
export const GET_SECTION_DATA = 'GET_SECTION_DATA'
export const SET_SECTION_DATA = 'SET_SECTION_DATA'
export const DELETE_SECTION = 'DELETE_SECTION'
export const DELETE_SECTION_PROCESSING = 'DELETE_SECTION_PROCESSING'
export const SET_SECTIONS_PROCESSING = 'SET_SECTIONS_PROCESSING'
export const SET_SECTIONS_DATA = 'SET_SECTIONS_DATA'
export const SET_SECTIONS_ERROR = 'SET_SECTIONS_ERROR'
export const BATCH_GET_SECTIONS_DATA = 'BATCH_GET_SECTIONS_DATA'
export const UPDATE_SECTION_SUCCESS = 'UPDATE_SECTION_SUCCESS'
export const GET_ONBOARD_DATA = 'GET_ONBOARD_DATA'
export const SET_ONBOARD_DATA = 'SET_ONBOARD_DATA'
export const GET_LIST_SORT_ORDER_OPTIONS = 'GET_LIST_SORT_ORDER_OPTIONS'
export const SET_LIST_SORT_ORDER_OPTIONS = 'SET_LIST_SORT_ORDER_OPTIONS'
export const GET_DISPLAY_MODE_OPTIONS = 'GET_DISPLAY_MODE_OPTIONS'
export const SET_DISPLAY_MODE_OPTIONS = 'SET_DISPLAY_MODE_OPTIONS'
export const SET_SECTION_TEMP_VISIBILITY_DATA = 'SET_SECTION_TEMP_VISIBILITY_DATA'
export const GET_TOPICS_DATA = 'GET_TOPICS_DATA'
export const SET_TOPICS_DATA = 'SET_TOPICS_DATA'
export const GET_CONTENT_REFERENCE_TYPES = 'GET_CONTENT_REFERENCE_TYPES'
export const SET_CONTENT_REFERENCE_TYPES = 'SET_CONTENT_REFERENCE_TYPES'
export const GET_CONTENT_FILTERS = 'GET_CONTENT_FILTERS'
export const SET_CONTENT_FILTERS = 'SET_CONTENT_FILTERS'

export function setSectionTempVisibilityData (payload) {
  return {
    type: SET_SECTION_TEMP_VISIBILITY_DATA,
    payload,
  }
}

export function createSection (payload) {
  return {
    type: CREATE_SECTION,
    payload,
  }
}

export function updateSectionData (payload) {
  return {
    type: UPDATE_SECTION_DATA,
    payload,
  }
}

export function updateSectionSuccess () {
  return {
    type: UPDATE_SECTION_SUCCESS,
  }
}

export function getSectionData (payload) {
  return {
    type: GET_SECTION_DATA,
    payload,
  }
}

export function setSectionData (payload) {
  return {
    type: SET_SECTION_DATA,
    payload,
  }
}

export function deleteSection (payload) {
  return {
    type: DELETE_SECTION,
    payload,
  }
}

export function deleteSectionProcessing (payload) {
  return {
    type: DELETE_SECTION_PROCESSING,
    payload,
  }
}

export function batchGetSectionsData (payload) {
  return {
    type: BATCH_GET_SECTIONS_DATA,
    payload,
  }
}

export function setSectionsProcessing (payload) {
  return {
    type: SET_SECTIONS_PROCESSING,
    payload,
  }
}

export function setSectionsData (payload) {
  return {
    type: SET_SECTIONS_DATA,
    payload,
  }
}

export function setSectionsError (payload) {
  return {
    type: SET_SECTIONS_ERROR,
    payload,
  }
}

export function getOnboardData (payload) {
  return {
    type: GET_ONBOARD_DATA,
    payload,
  }
}

export function setOnboardData (payload) {
  return {
    type: SET_ONBOARD_DATA,
    payload,
  }
}

export function getTopicsData () {
  return {
    type: GET_TOPICS_DATA,
  }
}

export function setTopicsData (payload) {
  return {
    type: SET_TOPICS_DATA,
    payload,
  }
}

export function getContentReferenceTypes () {
  return {
    type: GET_CONTENT_REFERENCE_TYPES,
  }
}

export function setContentReferenceTypes (payload) {
  return {
    type: SET_CONTENT_REFERENCE_TYPES,
    payload,
  }
}

export function getContentFilters (payload) {
  return {
    type: GET_CONTENT_FILTERS,
    payload,
  }
}

export function setContentFilters (payload) {
  return {
    type: SET_CONTENT_FILTERS,
    payload,
  }
}

export function getListSortOrderOptionsData (payload) {
  return {
    type: GET_LIST_SORT_ORDER_OPTIONS,
    payload,
  }
}

export function setListSortOrderOptionsData (payload) {
  return {
    type: SET_LIST_SORT_ORDER_OPTIONS,
    payload,
  }
}

export function getDisplayModeOptionsData (payload) {
  return {
    type: GET_DISPLAY_MODE_OPTIONS,
    payload,
  }
}

export function setDisplayModeOptionsData (payload) {
  return {
    type: SET_DISPLAY_MODE_OPTIONS,
    payload,
  }
}
